import * as React from 'react'
import { BasePage } from 'app/shared/components/base/BasePage'
import useBasePage from 'app/shared/hooks/base-page.hook'
import DOMPurify from 'dompurify'
import _ from 'lodash'
import {
    DateConversionInfo,
    useCommonCode,
} from 'app/shared/hooks/util/commonCode.hook'

/**
 * ======================================================================
 * @ 업무설명 : 일자전환관리
 * @ 파 일 명 : src\app\pages\auth\DateConversion.tsx
 * @ 화면  ID : SC-ETC-2003-F
 * ======================================================================
 * 번호  작업자           작업일         변경내용
 * ======================================================================
 * 1     김상돈(S24069)   2025.07.25     최초작성
 * ======================================================================
 */

const DateConversion: React.FC = () => {
    const router = useBasePage()

    const { data, trigger } = useCommonCode<DateConversionInfo>({
        fetchOnLoad: false,
        skipProgress: true,
        dsrnTgtBacd: '113',
        ccddId: '',
        cdgpId: '',
    })

    React.useEffect(() => {
        trigger()
        const intervalId = setInterval(() => {
            trigger()
        }, 30 * 1000)

        return () => clearInterval(intervalId)
    }, [])

    React.useEffect(() => {
        if (data) {
            if (data.data.fnsgYn === 'Y') {
                router.goHome(true)
            }
        }
    }, [JSON.stringify(data)])

    return (
        <BasePage header={false} className="pt-24">
            <div className="common-result-fail">
                <h2 className="h4">잠시 후 다시 이용해주세요</h2>
                <p
                    className="p-text"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                            _.unescape(router.location.state?.['msg'])
                        ),
                    }}
                />
            </div>
        </BasePage>
    )
}

export default DateConversion
